// extracted by mini-css-extract-plugin
export default {"star_size":"Star_star_size__PKalT"};